import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import {userAccessTokenSelector} from "../../../security";
const workflowController = new WorkFlowController();

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

export const setSelectedLocation: Action = createAction(
  ActionTypes.SET_SELECTED_LOCATION
);

const fetchLocations = async (options) => await workflowController.findWhere("location", {}, options);

export const fetchLocationsReceived: Action = createAction(
  ActionTypes.FETCH_ALL_LOCATIONS_COMPLETED
);

export const fetchAllLocations = () => async (dispatch, getState) => {
  dispatch(fetchLocationRequested())
  try {
    const locations = await fetchLocations({token: userAccessTokenSelector(getState())});
    dispatch(fetchLocationsReceived(locations));
  } catch(err) {
    dispatch(fetchLocationFailed(err.message[0].msg))
  }
};


const fetchLocationRequested: Action = createAction(
  ActionTypes.FETCH_LOCATION_REQUESTED
);

const fetchLocationFailed: Action = createAction(
  ActionTypes.FETCH_LOCATION_FAILED
);
export const fetchLocationReceived: Action = createAction(
  ActionTypes.FETCH_LOCATION_RECEIVED
);

const fetchLocationAPI = async (locationId, options) => workflowController.findOne("location", {locationId}, options)
export const fetchLocation = locationId => async (dispatch, getState) => {
  dispatch(fetchLocationRequested(locationId));
  try {
    const location = await fetchLocationAPI(locationId, {token: userAccessTokenSelector(getState())})
    dispatch(fetchLocationReceived(location))
  } catch(err) {
    dispatch(fetchLocationFailed(err.message[0].msg));
  }
};

const createLocationRequested: Action = createAction(
  ActionTypes.CREATE_LOCATION_REQUESTED
);

const createLocationReceived: Action = createAction(
  ActionTypes.CREATE_LOCATION_RECEIVED
);

const createLocationFailed: Action = {
  type: ActionTypes.CREATE_LOCATION_FAILED
};

export const createLocation = (locationName, address) => {
  return async (dispatch, getState) => {
    dispatch(createLocationRequested(locationName));
    try {
      const handledCommand = await workflowController.create("location", {locationName, address}, {token: userAccessTokenSelector(getState())});
      dispatch(createLocationReceived(handledCommand.locationId));
      dispatch(fetchLocation(handledCommand.locationId));
      dispatch(setSelectedLocation(handledCommand.locationId));
    } catch (err) {
      dispatch(createLocationFailed);
    }
  };
};

export const updateLocationRequested: Action = createAction(
  ActionTypes.UPDATE_LOCATION_REQUESTED
);

export const updateLocationReceived: Action = createAction(
  ActionTypes.UPDATE_LOCATION_RECEIVED
);

export const updateLocationFailed: Action = createAction(
  ActionTypes.UPDATE_LOCATION_FAILED
);

const updateLocationAPI = async (data, options) => await workflowController.execute("location", null, 'update_v4', data, options)
export const updateLocation = (locationId, locationName, streetAddress, city, postalCode, province, country, logoUrl, companyName, payableTo, additionalBuildings) => {
  return async (dispatch, getState) => {
    dispatch(updateLocationRequested());
    try {
      const handledCommand = await updateLocationAPI({ locationId, locationName, streetAddress, city, postalCode, province, country, logoUrl, companyName, payableTo, additionalBuildings}, {token: userAccessTokenSelector(getState())})
      dispatch(updateLocationReceived());
      setTimeout(() => dispatch(fetchLocation(handledCommand.locationId)), 500);
    } catch (err) {
      dispatch(updateLocationFailed(err.message[0].msg));
    }
  };
};



// WEBPACK FOOTER //
// ./src/features/location/store/locationActions.js